module.exports = __webpack_public_path__ + "img/rbm-features.2dd82743.png";